import React from 'react';

import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import TasksGoalsContainer from '../TasksGoalsContainer';
import JobFunctionRoleError from './JobFunctionRoleError';
import LevelUpViews from './LevelUpViews';
import { RoleSelectionSidePanel } from './RoleSelectionSidePanel/RoleSelectionSidePanel';

const LevelUp = ({ employee, checkInInstanceId, checkInParentId, filterEmpIds, isOneOnOne = false }) => (
  // check if employee doesn't have jobFunctionId or jobRoleId, show error screen.

  <TasksGoalsContainer>
    <FullHeightBox flexcontainer justifycontent="flex-start" alignitems="center" flexdirection="column">
      {employee?.jobFunctionId && employee?.jobRoleId ? (
        <>
          <LevelUpViews employee={employee} isOneOnOne={isOneOnOne} />
          <RoleSelectionSidePanel />
        </>
      ) : (
        <JobFunctionRoleError />
      )}
    </FullHeightBox>
  </TasksGoalsContainer>
);
export default LevelUp;

const StyledImage = styled.img`
  width: 100%;
`;

const FullHeightBox = styled(StyledBox)`
  height: 100%;
`;
